import React from 'react';
import {
  Grid,
  Typography,
  Divider,
  useTheme,
  useMediaQuery,
  DialogTitle,
  DialogContentText,
  DialogContent,
  Dialog,
} from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PickUp from 'components/pickAndDrop/PickUp';
import profile from 'assets/images/ProfileVendor.svg';
import share from 'assets/images/Share.svg';
import call from 'assets/images/callLogo.svg';

function CommonSosDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClickOpen = () => {
    //TODO we will use in sos
    // props.setOpenDialog(true);
  };

  const handleClose = () => {
    //TODO we will use in sos
    props.handleClose()
  };
  const sosAlertData = props?.sosAlertData?.data?.map((e) => e);

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={handleClickOpen}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <Grid>
            {/* ---Close Button--- */}
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
          {/* ---Heading--- */}
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="marginTop25"
          >
            <Grid container item xs={10} alignItems="center">
              <Grid item xs={3} className="">
                <img src={profile} alt="profileimg" />
              </Grid>
              <Grid item xs={9}>
                <Typography className="font36 colorRed fontMedium">
                  SOS Press By Rider
                </Typography>
                <Typography className="font36 colorRed fontMedium">
                  ID: 8984
                </Typography>
              </Grid>
            </Grid>
            <Grid
              item
              container
              xs={2}
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
            >
              <Grid item>
                <img src={share} alt="shareimage" className='cursor' />
              </Grid>
            </Grid>
          </Grid>
        </DialogTitle>
        {/* ---Body--- */}
        <DialogContent className="padding0">
          <DialogContentText>
            {/* ---Body1--- */}
            <Grid container>
              <Grid item xs={12} className="">
                <Grid
                  item
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className="marginBottom25 marginTop formPadding"
                >
                  <Grid item xs={5}>
                    <Typography className="colorBlue font20 fontMedium">
                      Rider Details
                    </Typography>
                    <Typography className="font18 fontNormal">Saske</Typography>
                    <Typography className="font18 fontNormal">
                      9012341236
                    </Typography>
                    <Typography className="font18 fontNormal">
                      saske@uchiha.com
                    </Typography>
                  </Grid>
                  <Divider orientation="vertical" flexItem />
                  <Grid item xs={5}>
                    <Typography className="colorBlue font20 fontMedium">
                      Driver Details
                    </Typography>
                    <Typography className="font18 fontNormal">
                      Babu Bhaiya
                    </Typography>
                    <Typography className="font18 fontNormal">
                      8912390812
                    </Typography>
                    <Typography className="font18 fontNormal">
                      babu@stargarag.com
                    </Typography>
                  </Grid>
                </Grid>
                {/* ---Body2--- */}
                <Grid
                  container
                  className="marginBottom25 marginTop backgroundPrimary formPadding padding10"
                >
                  <Grid
                    item
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    className='padding10'
                  >
                    <Grid item>
                      <Typography className="font20 fontMedium">
                        SOS Location <span>23:39 PM</span>
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography>
                        <button className="vendorMapBtn">Map View</button>
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Typography className="font16 fontNormal padding10">
                      Bannerghatta Road. Near Jayadeva Hospital, Bannerghatta
                      Road, Opp Shoppers Stop, Bengaluru, Karnataka 560076{' '}
                    </Typography>
                  </Grid>
                </Grid>
                {/* ---Body3--- */}

                <Typography className="colorBlue font28 fontMedium formPadding">
                  Nearest emergency service
                </Typography>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-evenly"
                  alignItems="center"
                  className="formPadding marginbottom20"
                >
                  <Grid
                    item
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    xs={6}
                  >
                    <Grid item>
                      <img src={call} alt="calllogo" className="width20 marginRight10" />
                    </Grid>
                    <Grid item>
                      <Typography className="font20 fontMedium colorBlack">
                        Instant Service
                      </Typography>
                      <Typography className="font20 fontMedium colorBlack">
                        +91 909823412
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    xs={6}
                  >
                    <Grid item>
                      <img src={call} alt="calllogo" className="width20 marginRight10" />
                    </Grid>
                    <Grid item>
                      <Typography className="font20 fontMedium colorBlack">
                        Speedy Call
                      </Typography>
                      <Typography className="font20 fontMedium colorBlack">
                        +91 565432728
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                {/* ---Body4--- */}
                <Grid className="formPadding">
                  <PickUp />
                </Grid>

                {/* ---Body5--- */}
                <Typography className="colorBlue font20 fontMedium formPadding marginBlock10">
                  Rahulss emergency contacts
                </Typography>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-evenly"
                  alignItems="center"
                  className="formPadding marginbottom20"
                >
                  <Grid
                    item
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    xs={4}
                  >
                    <Grid item>
                      <img src={call} alt="calllogo" className="width20 marginRight10" />
                    </Grid>
                    <Grid item>
                      <Typography className="font20 fontMedium colorBlack">
                        Instant Service
                      </Typography>
                      <Typography className="font20 fontMedium colorBlack">
                        +91 909823412
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    xs={4}
                  >
                    <Grid item>
                      <img src={call} alt="calllogo" className="width20 marginRight10" />
                    </Grid>
                    <Grid item>
                      <Typography className="font20 fontMedium colorBlack">
                        Speedy Call
                      </Typography>
                      <Typography className="font20 fontMedium colorBlack">
                        +91 565432728
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    xs={4}
                  >
                    <Grid item>
                      <img src={call} alt="calllogo" className="width20 marginRight10" />
                    </Grid>
                    <Grid item>
                      <Typography className="font20 fontMedium colorBlack">
                        Speedy Call
                      </Typography>
                      <Typography className="font20 fontMedium colorBlack">
                        +91 565432728
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default CommonSosDialog;
